import { ID, Timestamp } from '@griply/types';

type CompletedCalendarTask = {
  parentIds?: string[] | null;
  archivedAt?: Timestamp | null;
  goalId?: ID | null;
};

// Mirrors the three drops the uncompleted calendar read gets from its filters.
export const filterCompletedCalendarTasks = <T extends CompletedCalendarTask>(
  tasks: T[],
  archivedGoalIds: ID[] = [],
): T[] =>
  tasks.filter(
    (task) =>
      !task.parentIds?.length &&
      !task.archivedAt &&
      !(task.goalId && archivedGoalIds.includes(task.goalId)),
  );
